import { getStorage, list, ref, getMetadata } from "firebase/storage";
import { firebaseApp } from "../../firebase/firebaseApp";
import { metadataDirPath } from "../patient/patientStoragePath";

/**
 * Returns newest metadata "age" info without downloading the JSON.
 *
 * Lists objects under the patient-scoped directory and selects the lexicographically
 * greatest filename (matching your naming scheme), then reads its Storage metadata.
 *
 * @param {string} uid
 * @param {string|null|undefined} [id]
 * @returns {Promise<{ latestMs: number|null, newestName: string|null }|null>}
 */
export async function fetchLatestMetadataInfo(uid, id) {
  if (!uid) throw new Error("fetchLatestMetadataInfo: uid is required");

  const storage = getStorage(firebaseApp);
  const dirRef = ref(storage, metadataDirPath(uid, id));

  let pageToken = undefined;
  let newestRef = null;

  do {
    // eslint-disable-next-line no-await-in-loop
    const res = await list(dirRef, { maxResults: 1000, pageToken });

    for (const item of res.items) {
      if (!newestRef || item.name.localeCompare(newestRef.name) > 0) {
        newestRef = item;
      }
    }

    pageToken = res.nextPageToken;
  } while (pageToken);

  if (!newestRef) return null;

  const meta = await getMetadata(newestRef);
  const t = Date.parse(meta.updated || meta.timeCreated || "");

  return {
    latestMs: Number.isFinite(t) ? t : null,
    newestName: newestRef.name,
  };
}
